import { Car } from "../types/car.types";

const calculateCarHealth = (car: Car) => {
  let score = 100;

  const lastServiceDate = car.lastServiceDate
    ? new Date(car.lastServiceDate)
    : null;
  if (lastServiceDate) {
    const diff = Date.now() - lastServiceDate.getTime();
    const months = diff / (1000 * 60 * 60 * 24 * 30);
    if (months > 6) score -= 20;
    if (months > 12) score -= 40;
  }

  const kms = Number(car.kms);
  if (kms > 100000) score -= 15;
  if (kms > 150000) score -= 25;

  const insurance = car.insuranceExpiry ? new Date(car.insuranceExpiry) : null;
  if (insurance && insurance.getTime() < Date.now()) {
    score -= 30;
  }

  const age = new Date().getFullYear() - Number(car.year);
  if (age > 8) score -= 15;
  if (age > 12) score -= 30;

  if (score < 0) score = 0;
  return score;
};

export { calculateCarHealth };
